import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Navbar from './components/Navbar.jsx';
import Home from './components/Home';
import Products from './components/Products';
import Terms from './components/Terms';
import Brainrot from './components/Brainrot';

import PageNotFound from './components/PageNotFound';

import AnimatedBackground from './components/AnimatedBackground.jsx';

function App() {
    return (
        <Router>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Products" element={<Products />} />
                <Route path="/Terms" element={<Terms />} />
                <Route path="/Brainrot" element={<Brainrot />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
            <AnimatedBackground />
      </Router>
      
    );
  }

export default App;